import { env } from 'constants';

function useItemPath(item) {
  if (!item?.id) {
    return '';
  }
  if (env.IS_CATERING && !env.IS_MARKETPLACE) {
    return `/item/${item.id}`;
  }
  return `/place/${item.restaurant}/item/${item.id}`;
}

export default useItemPath;
